export default __webpack_public_path__ + "3d06f66530aaaf83c03514054d0ee1b4.gif";